import fetcher from 'lib/fetcher';
import useSWR from 'swr';

interface IApartmentBuildingAreaMinMax {
  min: number;
  max: number;
}

const useApartmentBuildingAreaMinMax = (id?: number | null, type?: number | null) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    id && type ? `/building/${id}/available-area-limits` : null,
    (url) =>
      id && type
        ? fetcher.swr<IApartmentBuildingAreaMinMax>(url, {
            params: { typeId: type },
          })
        : null,
    {},
  );

  return { minMaxArea: data, error, isLoading, isValidating, mutate };
};

export default useApartmentBuildingAreaMinMax;
